import React, { useEffect, useRef } from "react";
import "./ConfirmDialog.css";

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    message?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    danger?: boolean;
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
    loading?: boolean;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    open,
    title = "Confirmation",
    message = "Êtes-vous sûr ?",
    confirmText = "Confirmer",
    cancelText = "Annuler",
    danger = false,
    onConfirm,
    onCancel,
    loading = false,
}) => {
    const backdropRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onCancel();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onCancel]);

    if (!open) return null;

    return (
        <div
            ref={backdropRef}
            className="cd-backdrop"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cd-title"
            onMouseDown={(e) => {
                if (e.target === backdropRef.current) onCancel();
            }}
        >
            <div
                className="cd-modal"
                role="document"
                onMouseDown={(e) => e.stopPropagation()}
            >
                <h3 id="cd-title" className="cd-title">{title}</h3>
                <div className="cd-message">{message}</div>
                <div className="cd-actions">
                    <button type="button" className="cd-btn" onClick={onCancel} disabled={loading}>
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        className={`cd-btn ${danger ? "cd-btn-danger" : "cd-btn-primary"}`}
                        onClick={() => { if (!loading) void onConfirm(); }}
                        disabled={loading}
                    >
                        {loading ? "Veuillez patienter..." : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
